export default (body) => {
  if (body.includes('\n')) {
    return `<p>${body.replace(/\n/g, '</p><p>')}</p>`;
  }
  return body;
};
